export default "__VITE_ASSET__178f564f__"